// extracted by mini-css-extract-plugin
export default {"number-of-sets":"NumberOfSets_number-of-sets__rcBuL"};